export default __webpack_public_path__ + "static/media/capa.a06565af.png";